"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateListCreator = void 0;
const common_1 = require("@finley-technologies/common");
const configs = __importStar(require("../configs"));
/**
 * Returns a function that creates a list of dates based on the type of recurring date config
 */
const getDateListCreator = (type) => {
    switch (type) {
        case 'calendarDate':
            return configs.calendarDate.createDateList;
        case 'startOf':
            return configs.startOrEndOfPeriod.createDateList;
        case 'endOf':
            return configs.startOrEndOfPeriod.createDateList;
        case 'weekday':
            return configs.weekday.createDateList;
        case 'weekdayByOccurrence':
            return configs.weekdayByOccurrence.createDateList;
        default:
            return (0, common_1.finleyAssertUnreachable)(type);
    }
};
exports.getDateListCreator = getDateListCreator;
//# sourceMappingURL=dateList.js.map